import { Component } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { TranslatePipe } from '@ngx-translate/core';
import { BookDemoDirective } from '../../directives/book-demo.directive';

@Component({
  selector: 'maximizer-showcase-sales-intelligence-page',
  standalone: true,
  imports: [KENDO_BUTTON, TranslatePipe, BookDemoDirective],
  templateUrl: './sales-intelligence.page.html',
  styleUrl: './sales-intelligence.page.scss',
})
export class SalesIntelligencePage {}
